module.exports = __webpack_public_path__ + "static/media/motobike_noti.7cc64928.svg";